import { fetchUserAttributes, fetchAuthSession } from "aws-amplify/auth";

export const getUserAttributes = async (dispatch) => {
  try {
    const attributes = await fetchUserAttributes();
    dispatch({ type: "SET_USER_ATTRIBUTES", payload: attributes }); 
  } catch (error) {
    console.error("Failed to fetch user attributes:", error);
  }
};

export const fetchUserRoles = async (dispatch) => {
    try {
      const session = await fetchAuthSession(); // Fetch the session
      const groups = session.tokens.idToken.payload["cognito:groups"] || []; // Extract user groups
      dispatch({ type: "SET_USER_ROLES", payload: groups }); // Save roles to global state
      return groups; // Return roles for further use if needed
    } catch (error) {
      console.error("Error fetching user roles:", error);
      throw error; // Re-throw the error if needed
    }
  };